import { AST } from '@handlebars/parser';
import { DEFAULT_LOCATION as loc } from '../../source/location';
import { NodeType } from '../../node/types';

type Config = Required<Pick<AST.MustacheStatement, 'path' | 'params' | 'hash'>> &
  Partial<AST.MustacheStatement>;

export const createMustacheStatement = (config: Config): AST.MustacheStatement => ({
  type: NodeType.MustacheStatement,
  escaped: true,
  strip: { close: false, open: false },
  loc,
  ...config,
});
